import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = (props) => {

    if(!props.show)
    {
        return null;
    }

    return (
        <div className="modal" onClick={props.onClose}>
        <div className="modal-dialog">
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h5 className="modal-title">{props.header}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.onClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>{props.content}</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={props.onClose}>Close</button>
              <button type="button" className="btn btn-primary" onClick={props.submitFunction}>OK</button>
            </div>
          </div>
        </div>
      </div>
    )
}

export default ConfirmationModal;